var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-491 -5220)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(491 5220)",
    fill: "#384455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.02,5258.993a4.869,4.869,0,0,1-5.031-4.676v-4.867a4.87,4.87,0,0,1,5.031-4.678h1a1,1,0,1,1,0,2h-1a2.791,2.791,0,0,0-2.884,2.681v4.867A2.792,2.792,0,0,0,515.02,5257h11.952a2.791,2.791,0,0,0,2.883-2.681v-4.878a2.78,2.78,0,0,0-2.871-2.67h-1.012a1,1,0,1,1,0-2h1.012a4.859,4.859,0,0,1,5.018,4.667v4.878a4.867,4.867,0,0,1-5.03,4.676Zm4.9-6.986v-10.6l-1.295,1.21a1.157,1.157,0,0,1-1.519,0,.948.948,0,0,1,0-1.41l3.131-2.923a1.2,1.2,0,0,1,1.522,0l3.131,2.923a.949.949,0,0,1,0,1.41,1.134,1.134,0,0,1-1.52,0l-1.3-1.21v10.6Z",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.15b0a2a68f9fa5b38e9963fbf288eef3.svg";
export { ForwardRef as ReactComponent };